import { render, staticRenderFns } from "./ProductAnalysisDisplay.vue?vue&type=template&id=0325f04a&scoped=true"
import script from "./ProductAnalysisDisplay.vue?vue&type=script&lang=ts"
export * from "./ProductAnalysisDisplay.vue?vue&type=script&lang=ts"
import style0 from "./ProductAnalysisDisplay.vue?vue&type=style&index=0&id=0325f04a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325f04a",
  null
  
)

export default component.exports